import React, { useEffect } from "react";
import "./i18n/i18n";
import "./setupAxios";
import axios from "axios";
import App from "./app/App";
import { Provider } from "react-redux";
import ReactDOM from "react-dom/client";
import { BASE_URL } from "./constants";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import LanguageProvider from "./context/LanguageProvider";
import { BrowserRouter } from "react-router-dom";
import { store } from "./redux/store";
import "react-toastify/dist/ReactToastify.css";
import "./assets/styles/reset-css.css";
import "./assets/styles/variables.css";
import "./index.module.scss";
import { Suspense } from "react";
import { Loader } from "./component/common/loader";
import { ConfigProvider as PhoneInputConfigProvider } from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "flagpack/dist/flagpack.css";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

axios.defaults.baseURL = BASE_URL;

const stripe = loadStripe(
  window.location.host === "portal.alyanaapp.com"
    ? "pk_test_51SATCVFD3qtGqMc2gPXZBR2NRQB1q509BoILG6GKauchKITfMErmrxbLcRKzA1Y1J0h4p3ZAAVPrabhz7T0YoOfO00ZCpfQYFO"
    : "pk_test_51SATCVFD3qtGqMc2gPXZBR2NRQB1q509BoILG6GKauchKITfMErmrxbLcRKzA1Y1J0h4p3ZAAVPrabhz7T0YoOfO00ZCpfQYFO"
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Elements stripe={stripe}>
    <Provider store={store}>
      <LanguageProvider>
        <PhoneInputConfigProvider
          locale={en}
          areaMapper={(area) => ({
            ...area,
            emoji: <span className={`fp ${area.short.toLowerCase()}`} />,
          })}
        >
          <ToastContainer limit={1} />
          <BrowserRouter>
            <Suspense fallback={<Loader />}>
              <App />
            </Suspense>
          </BrowserRouter>
        </PhoneInputConfigProvider>
      </LanguageProvider>
    </Provider>
  </Elements>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
